export default __webpack_public_path__ + "static/media/AMEX-Color.86591126.svg";